/**
 * @generated SignedSource<<eaad45554658dc2d0ca600bacda9add5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompanionCareModality = "PROFESSIONAL_COACHING" | "THERAPY";
export type ThreadType = "WELLBEING" | "WORK";
export type ChatContextCompanionWidgetMutation$variables = {
  careModality?: CompanionCareModality | null | undefined;
  from?: string | null | undefined;
  message: string;
  threadType?: ThreadType | null | undefined;
  userId: string;
};
export type ChatContextCompanionWidgetMutation$data = {
  readonly createThread: {
    readonly __typename: "ThreadCreated";
    readonly chatChannelUrl: string;
    readonly threadId: string;
    readonly threadTitle: string | null | undefined;
    readonly threadType: ThreadType;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ChatContextCompanionWidgetMutation = {
  response: ChatContextCompanionWidgetMutation$data;
  variables: ChatContextCompanionWidgetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "careModality"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "threadType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "careModality",
        "variableName": "careModality"
      },
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "initialMessage",
        "variableName": "message"
      },
      {
        "kind": "Variable",
        "name": "threadType",
        "variableName": "threadType"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "createThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chatChannelUrl",
            "storageKey": null
          }
        ],
        "type": "ThreadCreated",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatContextCompanionWidgetMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatContextCompanionWidgetMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "512b74bdb2d80cfe57285c03f33b1b8d",
    "id": null,
    "metadata": {},
    "name": "ChatContextCompanionWidgetMutation",
    "operationKind": "mutation",
    "text": "mutation ChatContextCompanionWidgetMutation(\n  $userId: ID!\n  $message: String!\n  $from: String\n  $careModality: CompanionCareModality\n  $threadType: ThreadType\n) {\n  createThread(userId: $userId, initialMessage: $message, from: $from, careModality: $careModality, threadType: $threadType) {\n    __typename\n    ... on ThreadCreated {\n      threadId\n      threadTitle\n      threadType\n      chatChannelUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6eff8fd6f783522c8632a76f01ec107";

export default node;
